var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M2.499 4.5V0.5H9.75L11.5 2.25V11.5H2M9 0.5V3H11.5M8.25 9.5V6H10.25M8.25 7.75H9.75M1.5 6H2.25C3.25 6 3.375 6.625 3.375 7C3.375 7.375 3.25 8 2.25 8H1.625V9H1.5V6ZM4.75 9V6H5.6025C6.171 6 6.75 6.25 6.75 7.5C6.75 8.75 6.171 9 5.6025 9H4.75Z",
          stroke: "#FF0000",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }